import { render } from "./EmployeeDetailsView.vue?vue&type=template&id=fe822e54&scoped=true"
import script from "./EmployeeDetailsView.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailsView.vue?vue&type=script&lang=js"

import "./EmployeeDetailsView.vue?vue&type=style&index=0&id=fe822e54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe822e54"]])

export default __exports__